var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("\n        Naplánovat návštěvu\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('form', {
    staticClass: "form-inline",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.postVisit($event)
      }
    }
  }, [_c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "doctor"
    }
  }, [_vm._v("K doktorovi")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.doctorid),
      expression: "visit.doctorid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat doktora"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.doctorid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit doktora")]), _vm._v(" "), _vm._l((_vm.doctors), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.fullname))])
  })], 2), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.branchid),
      expression: "visit.branchid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "doctorHelp",
      "id": "doctor",
      "placeholder": "vybrat pobočku"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.branchid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.loadCalendar()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit pobočku")]), _vm._v(" "), _vm._l((_vm.branches), function(row) {
    return _c('option', {
      domProps: {
        "value": row.id
      }
    }, [_vm._v(_vm._s(row.label))])
  })], 2), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "doctorHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "operation"
    }
  }, [_vm._v("za účelem")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.purposeid),
      expression: "purposeid"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "aria-describedby": "operationHelp",
      "id": "operation"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.purposeid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.changeVisitDuration]
    }
  }, _vm._l((_vm.visit_purposes), function(visit_purpose) {
    return _c('option', {
      domProps: {
        "value": visit_purpose.id
      }
    }, [_vm._v(_vm._s(visit_purpose.purpose))])
  })), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "operationHelp"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "mr-sm-2",
    attrs: {
      "for": "duration"
    }
  }, [_vm._v("Délka návštěvy:")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.visit.duration),
      expression: "visit.duration"
    }],
    staticClass: "form-control mr-sm-2",
    attrs: {
      "id": "duration"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.visit.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.changeSelectedWindows()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": ""
    }
  }, [_vm._v("zvolit čas")]), _vm._v(" "), _vm._l((24), function(duration) {
    return _c('option', {
      domProps: {
        "value": duration
      }
    }, [_vm._v(_vm._s(duration * 5) + " minut")])
  })], 2), _vm._v(" "), (!_vm.waitForSave) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Přidat návštěvu")]) : _c('button', {
    staticClass: "btn btn-primary disabled",
    attrs: {
      "disabled": "disabled"
    }
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-pulse fa-fw"
  }), _vm._v(" Ukládám")])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.actual_select.selected) ? _c('div', [_vm._v("\n            " + _vm._s(_vm.moment(_vm.actual_select.date).format('dddd')) + " " + _vm._s(_vm.moment(_vm.actual_select.date).format('LL')) + " v " + _vm._s(_vm.moment(_vm.actual_select.date).format('LT'))), _c('br')]) : _c('div', [_vm._v("\n            Vyberte den a čas v kalendáři\n        ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.previousPeriod() + _vm.getVisits()
      }
    }
  }, [_vm._v("Předchozí")])]), _vm._v(" "), _c('div', {
    staticClass: "btn-group",
    attrs: {
      "data-toggle": "buttons"
    }
  }, [_c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'day'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option1",
      "autocomplete": "off",
      "value": "day"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "day")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "day"
      }
    }
  }), _vm._v(" den\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'week'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option2",
      "autocomplete": "off",
      "value": "week"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "week")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "week"
      }
    }
  }), _vm._v(" týden\n                ")]), _vm._v(" "), _c('label', {
    staticClass: "btn btn-primary",
    class: {
      active: _vm.calendarSize === 'month'
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.calendarSize),
      expression: "calendarSize"
    }],
    attrs: {
      "type": "radio",
      "name": "options",
      "id": "option3",
      "autocomplete": "off",
      "value": "month"
    },
    domProps: {
      "checked": _vm._q(_vm.calendarSize, "month")
    },
    on: {
      "__c": function($event) {
        _vm.calendarSize = "month"
      }
    }
  }), _vm._v(" měsíc\n                ")])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.nextPeriod() + _vm.getVisits()
      }
    }
  }, [_vm._v("Následující")])])]), _vm._v(" "), _c('div', {
    staticClass: "justify-content-between d-flex"
  }, [_c('div'), _vm._v(" "), _c('div', [_vm._v("\n                " + _vm._s(_vm.get_params.from) + " - " + _vm._s(_vm.get_params.to) + "\n            ")]), _vm._v(" "), _c('div')]), _vm._v(" "), (_vm.visit.doctorid) ? _c('table', {
    staticClass: "table table_calendar"
  }, [_c('thead', [_c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / _vm.windowsPerHour)), function(times, index) {
    return _c('th', {
      attrs: {
        "colspan": _vm.windowsPerHour
      }
    }, [_vm._v("\n                    " + _vm._s((index + _vm.startHour) < 10 ? '0' + (index + _vm.startHour) : (index + _vm.startHour)) + "\n                ")])
  })], 2), _vm._v(" "), _c('tr', [_c('th'), _vm._v(" "), _vm._l((((_vm.endWindow - _vm.startWindow) / (_vm.windowsPerHour / 2))), function(times, index) {
    return _c('th', {
      staticClass: "halfHour",
      attrs: {
        "colspan": (_vm.windowsPerHour / 2)
      }
    }, [_vm._v("\n                     \n                ")])
  })], 2), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.hasData) ? _c('tbody', _vm._l(((this.end_date.diff(this.start_date, 'days') + 1)), function(n) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm.moment(_vm.start_date).add(n - 1, 'days').format('dddd'))), _c('br'), _c('small', [_vm._v(_vm._s(_vm.moment(_vm.start_date).add(n - 1, 'days').format('L')))])]), _vm._v(" "), _vm._l(((_vm.endWindow - _vm.startWindow)), function(cell, indexTM) {
      return _c('td', {
        class: _vm.getRightClassForTd(_vm.visits[_vm.moment(_vm.start_date).add(n - 1, 'days').format('YYYY-MM-DD')][_vm.startWindow + cell - 1]) + ' ' + ((cell % _vm.windowsPerHour === 0) ? 'hourly' : '') + ' ' + ((cell % _vm.windowsPerHour === _vm.windowsPerHour / 2) ? 'halfhourly' : ''),
        attrs: {
          "data-window-id": n + '_' + (_vm.startWindow + cell - 1)
        },
        on: {
          "mouseover": _vm.hoverWindows,
          "mouseleave": _vm.unhoverWindows,
          "click": function($event) {
            _vm.prepareVisit(_vm.startWindow + cell - 1, _vm.moment(_vm.start_date).add(n - 1, 'days'), $event)
          }
        }
      }, [_vm._v("\n                     \n                ")])
    })], 2)
  })) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-body text-left"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'ShowClient',
        params: {
          clientid: this.$route.params.clientid
        }
      }
    }
  }, [_vm._v("\n            zpět na klienta\n        ")])], 1)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('th')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38fecbfc","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Client/components/AddVisit.vue
// module id = 615
// module chunks = 0